import { css, FlattenSimpleInterpolation } from 'styled-components';

export const FontFamilyLato = (props: { size: string }): FlattenSimpleInterpolation => css`
  font-family: Lato;
  font-size: ${props.size};
`;

export const FontFamilyOswald = (props: { size: string }): FlattenSimpleInterpolation => css`
  font-family: Oswald;
  font-size: ${props.size};
`;
